import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './styles/Confirmation.css';

const Confirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { productName, amount } = location.state || {};

  if (!productName || !amount) {
    return (
      <main className="confirmation">
        <Helmet>
          <title>Erreur de confirmation - WinlyDeal</title>
          <meta name="robots" content="noindex, nofollow" />
          <meta name="description" content="Erreur lors de la confirmation du paiement sur WinlyDeal." />
        </Helmet>

        <div className="confirmation-container">
          <h1 className="confirmation-title">Erreur</h1>
          <p className="confirmation-text">Aucune information de paiement disponible.</p>
          <button className="confirmation-button" onClick={() => navigate('/')}>
            Retour à l'accueil
          </button>
        </div>
      </main>
    );
  }

  return (
    <main className="confirmation">
      <Helmet>
        <title>Merci pour votre contribution - WinlyDeal</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content={`Merci pour votre contribution de ${amount} € pour ${productName} sur WinlyDeal.`} />
      </Helmet>

      <div className="confirmation-container">
        <h1 className="confirmation-title">Paiement réussi ! 🎉</h1>
        <p className="confirmation-text">
          Merci pour votre contribution de <strong>{amount} €</strong> pour <strong>{productName}</strong>.
        </p>
        <button className="confirmation-button" onClick={() => navigate('/')}>
          Retour à l'accueil
        </button>
      </div>
    </main>
  );
};

export default Confirmation;
